export default __webpack_public_path__ + "static/media/mobileFIx.eb20a54b.jpg";